var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mui-bar mui-bar-nav",attrs:{"id":"headertop"}},[_c('header',[_c('a',{staticClass:"mui-icon mui-icon-left-nav mui-pull-left",on:{"click":_vm.back}}),_vm._v(" "),_c('h1',{staticClass:"mui-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"mui-right"},[_vm._t("mui-right")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe9bbd78","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/headertop.vue
// module id = null
// module chunks = 